<template>
    <el-container>
        <el-main>
            <el-card class="box-card">
                <template #header>
                    <div class="card-header">
                        <span> 绑定设备 </span>
                    </div>
                </template>
                <div>
                    <el-form>
                        <el-form-item label="网关">
                            <el-select
                                @change="gatewayChange"
                                v-model="gateway"
                                name="gateways"
                                clearable
                                filterable
                                default-first-option
                                placeholder="请选择网关"
                                :reserve-keyword="false"
                                :fit-input-width="true"
                                :allow-create="true">
                                <template v-for="(item, index) in gateways" :key="index">
                                    <el-option :label="item" :value="isNaN(Number(index)) === false ? Number(index) : index">
                                        <text>{{ item }}</text>
                                    </el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                        <template v-if="devices && device_brand === 1">
                            <el-tabs class="form-tabs" type="border-card">
                                <el-tab-pane key="lock" label="智能锁">
                                    <el-form-item label="智能锁">
                                        <el-select
                                            v-model="form.lock.id"
                                            name="lock"
                                            clearable
                                            filterable
                                            default-first-option
                                            placeholder="请选择智能锁"
                                            :reserve-keyword="false"
                                            :fit-input-width="true"
                                            :allow-create="true">
                                            <template v-for="(item, index) in devices" :key="index">
                                                <el-option v-if="[13,14,15,16,24].includes(item.type)" :label="item.title" :value="isNaN(Number(index)) === false ? Number(index) : index">
                                                    <text>{{ item.type_name }}：{{ item.title }}</text>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="提前开门时间">
                                        <el-select
                                            v-model="form.lock.ahead_time"
                                            name="lock"
                                            clearable
                                            filterable
                                            default-first-option
                                            placeholder="请选择提前开门时间"
                                            :reserve-keyword="false"
                                            :fit-input-width="true"
                                            :allow-create="true">
                                            <template v-for="(item, index) in times" :key="index">
                                                <el-option :label="item + '分钟'" :value="item">
                                                    <text>{{ item }}分钟</text>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="延后关门时间">
                                        <el-select
                                            v-model="form.lock.forward_time"
                                            name="lock"
                                            clearable
                                            filterable
                                            default-first-option
                                            placeholder="请选择智延后关门时间"
                                            :reserve-keyword="false"
                                            :fit-input-width="true"
                                            :allow-create="true">
                                            <template v-for="(item, index) in times" :key="index">
                                                <el-option :label="item + '分钟'" :value="item">
                                                    <text>{{ item }}分钟</text>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                </el-tab-pane>
                                <el-tab-pane key="switch" label="智能开关">
                                    <el-form-item label="智能开关">
                                        <el-select
                                            @change="switchChange"
                                            v-model="form.switch.id"
                                            name="switch"
                                            clearable
                                            filterable
                                            default-first-option
                                            placeholder="请选择智能开关"
                                            :reserve-keyword="false"
                                            :fit-input-width="true"
                                            :allow-create="true">
                                            <template v-for="(item, index) in devices" :key="index">
                                                <el-option v-if="[5,6,7,8,9,10].includes(item.type)" :label="item.type_name" :value="isNaN(Number(index)) === false ? Number(index) : index">
                                                    <text>{{ item.type_name }}: {{ item.title }}</text>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="智能开关">
                                        <formtable
                                            ref="table"
                                            v-model="form.switch.val"
                                            :forms="form.switch"
                                            :add-template="form.switch.config.template"
                                            :drag-sort="false"
                                            :hide-add="true"
                                            :hide-delete="true"
                                            placeholder="暂无数据">
                                        </formtable>
                                    </el-form-item>
                                </el-tab-pane>
                                <el-tab-pane key="socket" label="智能插座">
                                    <formtable
                                        ref="table"
                                        v-model="form.socket.val"
                                        :forms="form.socket"
                                        :add-template="form.socket.config.template"
                                        :drag-sort="false"
                                        :hide-add="false"
                                        :hide-delete="false"
                                        placeholder="暂无数据">
                                    </formtable>
                                </el-tab-pane>
                                <el-tab-pane key="horn" label="智能喇叭">
                                    <el-select
                                        v-model="form.horn.id"
                                        name="horn"
                                        clearable
                                        filterable
                                        default-first-option
                                        placeholder="请选择智能喇叭"
                                        :reserve-keyword="false"
                                        :fit-input-width="true"
                                        :allow-create="true">
                                        <template v-for="(item, index) in devices" :key="index">
                                            <el-option v-if="[4].includes(item.type)" :label="item.title" :value="isNaN(Number(index)) === false ? Number(index) : index">
                                                <text>{{ item.type_name }}: {{ item.title }}</text>
                                            </el-option>
                                        </template>
                                    </el-select>
                                </el-tab-pane>
                            </el-tabs>

                        </template>
                        <template v-if="devices && device_brand === 2">
                            <el-tabs class="form-tabs" type="border-card">
                                <el-tab-pane key="lock" label="智能锁">
                                    <el-form-item label="智能锁">
                                        <el-select
                                            v-model="form.lock.id"
                                            name="lock"
                                            clearable
                                            filterable
                                            default-first-option
                                            placeholder="请选择智能锁"
                                            :reserve-keyword="false"
                                            :fit-input-width="true"
                                            :allow-create="true">
                                            <template v-for="(item, index) in devices" :key="index">
                                                <el-option v-if="[24].includes(item.type)" :label="item.type_name" :value="isNaN(Number(index)) === false ? Number(index) : index">
                                                    <text>{{ item.type_name }}</text>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="提前开门时间">
                                        <el-select
                                            v-model="form.lock.ahead_time"
                                            name="lock"
                                            clearable
                                            filterable
                                            default-first-option
                                            placeholder="请选择提前开门时间"
                                            :reserve-keyword="false"
                                            :fit-input-width="true"
                                            :allow-create="true">
                                            <template v-for="(item, index) in times" :key="index">
                                                <el-option :label="item + '分钟'" :value="item">
                                                    <text>{{ item }}分钟</text>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="延后关门时间">
                                        <el-select
                                            v-model="form.lock.forward_time"
                                            name="lock"
                                            clearable
                                            filterable
                                            default-first-option
                                            placeholder="请选择智延后关门时间"
                                            :reserve-keyword="false"
                                            :fit-input-width="true"
                                            :allow-create="true">
                                            <template v-for="(item, index) in times" :key="index">
                                                <el-option :label="item + '分钟'" :value="item">
                                                    <text>{{ item }}分钟</text>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                </el-tab-pane>
                                <el-tab-pane key="switch" label="智能开关">
                                    <el-form-item label="智能开关">
                                        <el-select
                                            @change="switchChange"
                                            v-model="form.switch.id"
                                            name="switch"
                                            clearable
                                            filterable
                                            default-first-option
                                            placeholder="请选择智能开关"
                                            :reserve-keyword="false"
                                            :fit-input-width="true"
                                            :allow-create="true">
                                            <template v-for="(item, index) in devices" :key="index">
                                                <el-option v-if="[21].includes(item.type)" :label="item.type_name" :value="isNaN(Number(index)) === false ? Number(index) : index">
                                                    <text>{{ item.type_name }}</text>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="智能开关">
                                        <formtable
                                            ref="table"
                                            v-model="form.switch.val"
                                            :forms="form.switch"
                                            :add-template="form.switch.config.template"
                                            :drag-sort="false"
                                            :hide-add="true"
                                            :hide-delete="true"
                                            placeholder="暂无数据">
                                        </formtable>
                                    </el-form-item>
                                </el-tab-pane>
                                <el-tab-pane key="horn" label="智能喇叭">
                                    <el-select
                                        v-model="form.horn.id"
                                        name="horn"
                                        clearable
                                        filterable
                                        default-first-option
                                        placeholder="请选择智能喇叭"
                                        :reserve-keyword="false"
                                        :fit-input-width="true"
                                        :allow-create="true">
                                        <template v-for="(item, index) in devices" :key="index">
                                            <el-option v-if="[25].includes(item.type)" :label="item.type_name" :value="isNaN(Number(index)) === false ? Number(index) : index">
                                                <text>{{ item.type_name }}</text>
                                            </el-option>
                                        </template>
                                    </el-select>
                                </el-tab-pane>
                            </el-tabs>

                        </template>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="default"
                                @click="onSubmit">
                                提交
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
        </el-main>
    </el-container>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, toRaw, provide, reactive } from 'vue'
    import Formtable from '@/components/ui-form-page/items/formtable'
    export default defineComponent({
        components: {
            Formtable
        },
        setup() {
            const { proxy } = getCurrentInstance()
            const selectIds = ref()
            const urls = proxy.$router.currentRoute.value.meta.urls

            const map = ref(proxy.$router.currentRoute.value.query)
            const gateways = ref()
            const gateway = ref()
            const devices = ref(false)
            const socket = ref([])
            const device_brand = ref(1)
            const times = Array.from({ length: 61 }, (_, index) => index)
            const lines = Array.from({ length: 4 }, (_, index) => index)

            const form = ref({
                horn: {
                    id: ''
                },
                lock: {
                    id: '',
                    ahead_time: '',
                    forward_time: ''
                },
                socket: {
                    config: {
                        columns: {
                            line: {
                                label: '插座',
                                form: 'select',
                                default: '',
                                options: socket,
                                config: {
                                    key: 'title',
                                    value: 'id'
                                }
                            },
                            title: {
                                label: '备注名称',
                                form: 'text',
                                default: ''
                            },
                            ahead_time: {
                                label: '通电提前时间（分钟）',
                                form: 'select',
                                default: '',
                                options: times
                            },
                            forward_time: {
                                label: '断电延后时间（分钟）',
                                form: 'select',
                                default: '',
                                options: times
                            }
                        },
                        template: {
                            line: 0,
                            title: '',
                            ahead_time: 15,
                            forward_time: 5
                        }
                    },
                    val: JSON.stringify([])
                },
                switch: {
                    id: '',
                    config: {
                        columns: {
                            line: {
                                label: '线路',
                                form: 'select',
                                default: '',
                                options: lines
                            },
                            title: {
                                label: '备注名称',
                                form: 'text',
                                default: ''
                            },
                            ahead_time: {
                                label: '通电提前时间（分钟）',
                                form: 'select',
                                default: '',
                                options: times
                            },
                            forward_time: {
                                label: '断电延后时间（分钟）',
                                form: 'select',
                                default: '',
                                options: times
                            }
                        },
                        template: {
                            line: 1,
                            title: '',
                            ahead_time: 15,
                            forward_time: 5
                        }
                    },
                    val: JSON.stringify([])
                }
            })

            proxy.jiu.request(urls.list, map.value, 'GET').then((res, rej) => {
                let data = res.data
                device_brand.value = data.device_brand
                if (data.is_edit) {
                    devices.value = data.devices
                    for (let i in devices.value) {
                        if ([2, 3].includes(devices.value[i].type)) {
                            devices.value[i].title_display = devices.value[i].type_name + ':' + devices.value[i].title
                            socket.value.push(devices.value[i])
                        }
                    }
                    form.value.horn.id = data.form.horn.id
                    form.value.lock.id = data.form.lock.id
                    form.value.lock.ahead_time = data.form.lock.ahead_time
                    form.value.lock.forward_time = data.form.lock.forward_time
                    form.value.switch.id = data.form.switch.id
                    form.value.switch.val = data.form.switch.val
                    form.value.socket.val = data.form.socket.val
                    gateway.value = data.gateway_id
                }
                gateways.value = data.gateways
            }).catch((error) => {
                proxy.jiu.showError(error)
            })

            const gatewayChange = (e) => {
                let obj = Object.assign(map.value, { gateway_id: e })
                proxy.jiu.request(urls.list, obj, 'GET').then((res, rej) => {
                    devices.value = res.data.devices
                    device_brand.value = res.data.device_brand
                    for (let i in devices.value) {
                        if ([2, 3].includes(devices.value[i].type)) {
                            devices.value[i].title_display = devices.value[i].type_name + ':' + devices.value[i].title
                            socket.value.push(devices.value[i])
                        }
                    }
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const switchChange = (e) => {
                if (e) {
                    let type = devices.value[e].type
                    let vals = [{
                        line: 1,
                        title: '',
                        ahead_time: 15,
                        forward_time: 5
                    }]
                    if ([6, 7, 9, 10].includes(type)) {
                        vals.push({
                            line: 2,
                            title: '',
                            ahead_time: 15,
                            forward_time: 5
                        })
                    }
                    if ([7, 10].includes(type)) {
                        vals.push({
                            line: 3,
                            title: '',
                            ahead_time: 15,
                            forward_time: 5
                        })
                    }
                    form.value.switch.val = JSON.stringify(vals)
                } else {
                    form.value.switch.val = JSON.stringify([])
                }
            }

            const onSubmit = () => {
                let addObj = {
                    house_id: map.value.id,
                    gateway_id: gateway.value,
                    lock: form.value.lock.id,
                    lock_ahead_time: form.value.lock.ahead_time,
                    lock_forward_time: form.value.lock.forward_time,
                    horn: form.value.horn.id,
                    socket: form.value.socket.val,
                    switch: form.value.switch.id,
                    switch_line: form.value.switch.val
                }
                proxy.jiu.request(urls.list, addObj, 'POST').then((res, rej) => {
                    proxy.jiu.toast(res.message)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const useMergedRefs = (...refs) => {
                const mergedRef = ref(null)
                mergedRef.value = reactive({
                    ...refs.map(ref => ref.value)
                })
                return mergedRef
            }

            return {
                gateways,
                gateway,
                devices,
                form,
                times,
                device_brand,
                gatewayChange,
                switchChange,
                onSubmit
            }
        }
    })
</script>

<style scoped>

</style>
